export function SampleKit(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="20"
        height="24"
        viewBox="0 0 20 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.00005 0.300003C1.78502 0.300003 0.800049 1.28498 0.800049 2.5C0.800049 3.71503 1.78502 4.7 3.00005 4.7H3.80005V17.5C3.80005 20.9242 6.57588 23.7 10 23.7C13.4242 23.7 16.2 20.9242 16.2 17.5V4.7H17C18.2151 4.7 19.2001 3.71503 19.2001 2.5C19.2001 1.28498 18.2151 0.300003 17 0.300003H3.00005ZM6.20005 4.7H9V15.2676C8.69637 15.4432 8.4432 15.6964 8.26756 16C8.09739 16.2942 8 16.6357 8 17C8 18.1046 8.89543 19 10 19C11.1046 19 12 18.1046 12 17C12 16.6357 11.9026 16.2942 11.7324 16C11.5568 15.6964 11.3036 15.4432 11 15.2676V4.7H13.8V17.5C13.8 19.5987 12.0987 21.3 10 21.3C7.90137 21.3 6.20005 19.5987 6.20005 17.5V4.7Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
